function formatDate (str) {
	return `${str.substring(8, 10)}/${str.substring(5, 7)}/${str.substring(0, 4)}`;
}

function parseDate (str) {
	if (!str) {
		return null;
	}
	const [day, month, year] = str.split('/');
	if (!day || !month || !year) {
		return null;
	}
	return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}

export { formatDate, parseDate };
